// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.RecordFieldTypeEnum
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let RecordFieldTypeEnum = /*#__PURE__*/function (RecordFieldTypeEnum) {
  RecordFieldTypeEnum[RecordFieldTypeEnum["Base"] = 0] = "Base";
  RecordFieldTypeEnum[RecordFieldTypeEnum["Record"] = 1] = "Record";
  RecordFieldTypeEnum[RecordFieldTypeEnum["Vector"] = 2] = "Vector";
  return RecordFieldTypeEnum;
}({});
(function (_RecordFieldTypeEnum) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? RecordFieldTypeEnum[enumVal] != null ? enumVal : undefined : RecordFieldTypeEnum[enumVal];
  }
  _RecordFieldTypeEnum.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _RecordFieldTypeEnum.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _RecordFieldTypeEnum.indexOf = indexOf;
})(RecordFieldTypeEnum || (RecordFieldTypeEnum = {}));
//# sourceMappingURL=RecordFieldTypeEnum.js.map
